module.exports = __webpack_public_path__ + "8859082DD4A154ECB2EBD04ACD88B0FBrecommend2.fd6f311d.png";